$(function () {
  $(".c-accordion__head").on("click", function () {
    const accordion = $(this).closest(".c-accordion");

    // アコーディオングループが設定されていた場合、同グループで他に開いているアコーディオンを閉じる
    const accordionGroup = accordion.data("accordion_group");
    if (accordionGroup) {
      const openAccordion = $('[data-accordion_group="' + accordionGroup + '"].-accordion-open');
      if (!accordion.is(openAccordion)) {
        accordionActions(openAccordion);
      }
    }

    const accCallbackName = accordion.data("acc-callback");
    const accCallback = typeof window[accCallbackName] === "function" ? window[accCallbackName] : null;

    accordionActions(accordion, accCallback);
  });

  function accordionActions(target, callback) {
    const accordionHead = findFirstMatchingElement(target, ".c-accordion__head");
    const accordionBody = findFirstMatchingElement(target, ".c-accordion__body");

    if (accordionHead.length == 0 || accordionBody.length == 0) return;

    target.toggleClass("-accordion-open");
    accordionHead.toggleClass("-accordion-clicked");

    const safeCallback = callback || function () {};
    if (target.hasClass("-fade")) {
      accordionBody.fadeToggle(200, safeCallback);
    } else if (target.hasClass("-toggle")) {
      accordionBody.toggle(0, safeCallback);
    } else {
      accordionBody.slideToggle(150, "swing", safeCallback);
    }
  }

  /**
   * 指定の要素内で、指定したクラスを持つ最初の要素を見つける関数
   * @param {jQuery} root - 検索を開始する要素（jQueryオブジェクト）
   * @param {string} targetClass - 探索するクラス名
   * @returns {jQuery} - 最初に見つかった要素（jQueryオブジェクト）、見つからなければ空のjQueryオブジェクト
   */
  function findFirstMatchingElement(root, targetClass) {
    var $root = $(root);

    // まずは直下の子要素から探す
    var $firstMatch = $root.children(targetClass);

    // 直下の子要素に見つからない場合、再帰的に探索
    if ($firstMatch.length === 0) {
      $root.children().each(function () {
        var $match = findFirstMatchingElement(this, targetClass);
        if ($match.length > 0) {
          $firstMatch = $match;
          return false; // 最初に見つかったらループを終了
        }
      });
    }

    return $firstMatch; // 見つからなければ空のjQueryオブジェクトが返る
  }
});
